import { createSvgIcon } from '@mui/material';
// or with custom SVG
export const RectangleFilledIcon = createSvgIcon(
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_6658_31221)">
      <rect x="1.5" y="1.5" width="15" height="15" rx="4" fill="#32C27D" />
    </g>
    <defs>
      <filter
        id="filter0_d_6658_31221"
        x="0.5"
        y="0.5"
        width="17"
        height="17"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_6658_31221"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.196078 0 0 0 0 0.760784 0 0 0 0 0.490196 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6658_31221"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_6658_31221"
          result="shape"
        />
      </filter>
    </defs>
  </svg>,
  "RectangleFilled",
);

export default RectangleFilledIcon;
